import React, { PureComponent } from 'react';
import styled from 'styled-components';
import ComponentTitle from './ComponentTitle';
import UpdatedDate from './UpdatedDate';

const StyledSankeyComponent = styled.div`
  grid-column: span 12;
  @media (min-width: 1280px) {
    grid-column: span ${props => props.columns};
  }
  @media print {
    page-break-inside: avoid;
    margin-bottom: 30px;
    display: block;
  }
`;

const SankeyWrapper = styled.div`
  position: relative;
  background: white;
  padding-bottom: 30px;
  width: 100%;
  height: ${props => (props.heightInPx ? `${props.heightInPx}px` : '1000px')};
  position: relative;
  border-radius: 5px;
  box-shadow: 0 2px 4px 0 rgba(38, 47, 51, 0.3);
  overflow: hidden;
`;

class SankeyComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.iframeRef = React.createRef();
  }

  componentDidMount() {
    srcDoc.set(this.iframeRef.current, this.props.data); // eslint-disable-line no-script-url, no-undef
  }

  render() {
    const { title, info } = this.props;
    return (
      <StyledSankeyComponent columns={this.props.columns}>
        <ComponentTitle title={title} info={info} />
        <SankeyWrapper heightInPx={this.props.heightInPx}>
          <iframe
            ref={this.iframeRef}
            title={`Title${parseInt(Math.random() * 100000, 10)}`}
            style={{
              width: '100%',
              height: '100%',
              border: 0
            }}
          />
          <UpdatedDate>{`letztes Update: ${
            this.props.lastUpdated
          }`}</UpdatedDate>
        </SankeyWrapper>
      </StyledSankeyComponent>
    );
  }
}

export default SankeyComponent;
